
import React from 'react'
import Navbar from '../../components/modules/Navbar'
import './MazarsStyles.css'
import mazarsLogo from '../../assets/partenaires/logoMazars.png'
import { useState,useEffect } from 'react'
import CountUp from 'react-countup'
import Footer from '../../components/modules/Footer'
// import ScrollTrigger from 'react-scroll-trigger'
import {BsArrowRight} from 'react-icons/bs'
import {BsFileArrowDown} from 'react-icons/bs'
import { Link as LinkScroll} from 'react-scroll';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPluging from 'gsap/ScrollToPlugin'
import gsap from 'gsap';
import { useTranslation} from "react-i18next";



gsap.registerPlugin(ScrollTrigger,ScrollToPluging);

const Mazars = () => {
    const { t } = useTranslation('common');

        //Animation on scroll
        const onLoad = () =>{
            gsap.timeline().fromTo("#off",
            {
                y: 50,
                opacity:0,
            },
            {
                y:0,
                opacity:1,
                duration:1.5,
            })
        }
        const FadeBottom = (elem,time)=>{
            
            gsap.fromTo(
                elem,
                
                {
                  y:100,
                    opacity:0,
                    
        
                },
                {
                    opacity:1,
                   y:0, 
                   
                    duration:0.8,
                    delay:time,
                    scrollTrigger:{
                        trigger:elem,
                        start:"-50% 80%",
                        end:"bottom center",
                        
                        onEnter:setCounterOn(true),
                        toggleActions:"play none none none",
                        
                    },
                    
                }
               
            )
            
        }
     
        
      
      
        useEffect(()=>{
            onLoad();
        FadeBottom('#mazars-numbers1',0)
        FadeBottom('#mazars-numbers2',0.2)
        FadeBottom('#mazars-numbers3',0.4)
        FadeBottom('#mazars-numbers4',0.6)
        },[])


    const [counterOn, setCounterOn] = useState(false);

return ( 
<div>
    <Navbar scroll='true' color='#09208f'/>
            <div className='mazars'>
                <div className='mazars-title'>
                    <h3 id='off'> {t('mazars.title')}</h3>
                    <img  id='off' src={mazarsLogo} alt="" />
                    <h5 id='off'>{t('mazars.title2')} </h5>
                   <LinkScroll to='mazars-toss' smooth={true}  offset={0} duration={1000}> <BsFileArrowDown className='fleche-mazars'/></LinkScroll>
                </div>
                <div className='mazars-toss' id='mazars-toss'>
                    <h4>{t('mazars.firstP')}</h4>
                </div>
                <div className='mazars-presentation' id='mazars-presentation'>
                {/* <ScrollT onEnter={() => setCounterOn(true)} > */}
                    <h3> {t('mazars.title3')}</h3>
                    <div className='mazars-numbers' >
                        <div id='mazars-numbers1'>
                            <h6> {t('mazars.card1')}</h6>
                            <h4> {counterOn && <CountUp start ={0} end={100} duration={3} delay={0}></CountUp>}</h4>
                            <p> {t('mazars.card1b')}</p>
                        </div>
                        <div id='mazars-numbers2'>
                        <h6> {t('mazars.card2')}</h6>
                            <h4> {counterOn && <CountUp start ={0} end={45000} duration={3} delay={0.5}></CountUp>}</h4>
                            <p> {t('mazars.card2b')}</p>
                        </div>
                        
                        <div id='mazars-numbers4'>
                        <h6> {t('mazars.card4')}</h6>
                            <h4> {counterOn && <CountUp start ={0} end={700} duration={3} delay={1.5}></CountUp>}</h4>
                            <p> {t('mazars.card4b')}</p>
                        </div>
                    </div> 
                    {/* </ScrollT> */}
                    <h5> {t('mazars.sndP')} <span>{t('mazars.bold1')}</span>{t('mazars.sndP2')} <span>{t('mazars.bold2')}</span></h5>
                        <h2>{t('mazars.thirdP')} </h2>
                        <div className='mazars-numbers field'>
                            <div>
                                <h4> {t('mazars.card5')}</h4>
                            </div>
                            <div>
                            <h4> {t('mazars.card6')}</h4>
                            </div>
                            <div>
                            <h4> {t('mazars.card7')}</h4>
                            </div>
                            <div>
                            <h4> {t('mazars.card8')}</h4>
                            </div>
                            <div>
                            <h4> {t('mazars.card9')}</h4>
                            </div>
                            <div>
                            <h4> {t('mazars.card10')}</h4>
                            </div>
                        
                        </div>
                        <div className='mazars-numbers center'>
<div>
                        <h4> {t('mazars.card11')}</h4>
                        </div>
                        </div>
                     
                </div>
                <div className='mazars-recrutement'>
<h2> {t('mazars.title2')}</h2>
<div>
    <p>{t('mazars.lastP')}</p>
<div>
    <a href='https://www.mazarsrecrute.fr/'>{t('mazars.button')}<BsArrowRight className='fleche'/></a>
    </div>
</div>


                </div>
            </div>
            <Footer color='#09208f' color2='#0f1c5b'/>
        </div>
    )
}

export default Mazars